(function () {
  $('.capacity p a').click(function (e) {
    console.log($(this).index(), $(this).attr('data-url'));
    $(this).parents('.capacity').siblings('.buy_btn').attr('href', $(this).attr('data-url'));
    $(this).addClass('active_tag');
    $(this).siblings('a').removeClass('active_tag');
    $(this).parents('.capacity').siblings("[class^='price_item']").removeClass('price_avtive');
    $(this).parents('.capacity').siblings(`.price_item${$(this).index() + 1}`).addClass('price_avtive');
    return false;
  })


  $('.text_container .code_tag .copy_btn').click(function () {
    navigator.clipboard.writeText($(this).siblings('.code_text').text());
    $(this).text('√')
    setTimeout(() => {
      $(this).text('COPY');
    }, 3000);;
  })
  if ($(window).width() > 1200) {
    $(window).scroll(function () {
      var target = $(".bfcm23_banner2 .text_container").offset().top - $(window).height();
      var scrollTop = $(window).scrollTop();
      if (scrollTop >= target) {
        $('.bfcm23_banner2 .mask').fadeOut(700);
        $('.float_animation').css({ 'transform': 'translateY(0)', 'opacity': '1' });
      } else if (scrollTop < target) {
        $('.bfcm23_banner2 .mask').show();
        $('.float_animation').css({ 'transform': 'translateY(100%)', 'opacity': '0' });
      }
    })
  }


  if ($(window).width() > 590) {
    var mySwiper = new Swiper('.product_swiper', {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 20,
      keyboard: { enabled: true },
      breakpoints: {
        1280: {
          slidesPerView: 4,
          spaceBetween: 30
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 20
        }
      },
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev',
      }
    });
  }


  $('.fqa_item .question button').on('click', function (e) {
    e.stopPropagation();
    $(this).parents('.fqa_item').siblings().removeClass('answer_active')
    if ($(this).parents('.fqa_item').hasClass('answer_active')) {
      $(this).parents('.fqa_item').removeClass('answer_active');
    } else {
      $(this).parents('.fqa_item').addClass('answer_active');
    }
    $(this).parents('.fqa_item').siblings().find('.answer').slideUp();
    $(this).parent().siblings('.answer').slideToggle();
  })
  $('.fqa_item .question').on('click', function () {
    $(this).parents('.fqa_item').siblings().removeClass('answer_active');
    if ($(this).parents('.fqa_item').hasClass('answer_active')) {
      $(this).parents('.fqa_item').removeClass('answer_active');
    } else {
      $(this).parents('.fqa_item').addClass('answer_active');
    }
    $(this).parents('.fqa_item').siblings().find('.answer').slideUp();
    $(this).siblings('.answer').slideToggle();
  })

  $('.bfcm23_banner1 .fixed_icon').on('click', function () {
    if ($(window).width() > 590) {
      $(this).siblings('.fixed_box').css({ 'left': '35px', 'opacity': '1' });
    } else {
      $(this).siblings('.fixed_box').css({ 'left': '0', 'opacity': '1' });
    }
    $(this).css({ 'transform': 'translateX(100%)', 'opacity': '0' });
  })
  $('.fixed_box svg').on('click', function (e) {
    e.stopPropagation();
    $(this).parent().css({ 'left': '-50%', 'opacity': '0' });
    $(this).parent().siblings('.fixed_icon').css({ 'transform': 'translateX(0)', 'opacity': '1' });
  })
  $('body').on('click', '.close-wheel', function () {
    $('.bfcm23_banner1 .fixed_icon').css({ 'transform': 'translateX(0)', 'opacity': '1' });
    $('.bfcm23_banner1 .fixed_box').css({ 'left': '-50%', 'opacity': '0' });
  })


  $('.checked_nav').on('click', function () {
    $(this).children('svg').toggle();
    $(this).siblings().toggle(400);
  })
  $('.mb_nav .nav_list .nav_item').on('click', function (e) {
    e.stopPropagation();
    $('.checked_nav .title').text($(this).children('.title').text());
    $('.checked_nav .times').text($(this).children('.times').text());
    $(this).parent().toggle(400);
    let sectionid = $(this).attr('href');
    let scrollHeight = $(sectionid).offset().top - 50;
    if ($(window).scrollTop() < $('.bfcm23_banner2 .text_container .desc').offset().top) {
      scrollHeight -= 80;
    }
    $("html,body").animate({ scrollTop: scrollHeight }, 300);
  })

  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    var nav1_height = $('.bfcmbanner3').offset().top;
    var nav2_height = $('.bfcmbanner4').offset().top - 120;
    if (scrollTop >= nav1_height && scrollTop < nav2_height) {
      $('.checked_nav .title').text($('.mb_nav .nav_list').children().eq(1).children('.title').text());
      $('.checked_nav .times').text($('.mb_nav .nav_list').children().eq(1).children('.times').text());
    } else if (scrollTop >= nav2_height) {
      $('.checked_nav .title').text($('.mb_nav .nav_list').children().eq(2).children('.title').text());
      $('.checked_nav .times').text($('.mb_nav .nav_list').children().eq(2).children('.times').text());
    }
  })


  var target
  var taget_div
  if ($(window).width() > 590) {
    target = $('.bfcm23_banner1 .pc_nav').offset().top;
    taget_div = $('.bfcm23_banner1 .pc_nav');
  } else {
    target = $('.bfcm23_banner1 .mb_nav').offset().top;
    taget_div = $('.bfcm23_banner1 .mb_nav');
  }

  $(window).scroll(function () {

    var scrollTop = $(window).scrollTop();
    if (scrollTop >= target) {
      $(taget_div).css('position', 'fixed');
    } else if (scrollTop < target) {
      $(taget_div).css('position', 'unset');
    }
  })

  // 页面根据url的section参数跳转
  function getUrlParams() {
    var url = window.location.hash;
    if (url == '') {
      return false;
    }
    var className = url.substring(1);
    return className;
  }
  var sectionclass = getUrlParams();
  if (sectionclass) {
    setTimeout(function () {
      $(window).scrollTop($(`.${sectionclass}`).offset().top - 50)
    }, 500);
  }
})();